import { render } from "./LeaderboardPage.vue?vue&type=template&id=72cb117e"
import script from "./LeaderboardPage.vue?vue&type=script&lang=js"
export * from "./LeaderboardPage.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./LeaderboardPage.vue?vue&type=style&index=0&id=72cb117e&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script